const nlBlog = {
  meta: {
    title: "Blog | Ramen Repair Eindhoven — Tips & Subsidies",
    description:
      "Praktische tips over kozijnreparatie, raamonderhoud, ISDE-subsidie 2026 en energiebesparing. Advies van de specialisten van Ramen Repair Eindhoven.",
  },
  hero: {
    h1: "Blog : tips over kozijnen, ramen en subsidies",
    intro:
      "Welkom op onze blog. Hier delen wij praktisch advies over kozijnreparatie, raamonderhoud, energiebesparing en subsidies die u kunt aanvragen. Onze specialisten schrijven uit ervaring.",
  },
  articles: {
    h2: "Alle artikelen",
    readMore: "Lees meer",
    soon: "Binnenkort",
    items: [
      {
        title: "ISDE-subsidie 2026 : complete gids",
        excerpt:
          "Alles over de ISDE-subsidie 2026 voor energiezuinige ramen, HR++ glas en isolatie. Bedragen, voorwaarden en hoe u aanvraagt.",
        href: "/blog/isde-subsidie-2026/",
        status: "active",
        image:
          "/img/01-energy-efficient-hr-glass.jpg",
      },
      {
        title: "Condens op ramen oplossen",
        excerpt:
          "Waarom ontstaat condens en hoe voorkomt u vochtproblemen? Tips voor ventilatie, isolatie en betere beglazing.",
        href: "/blog/condens-ramen-oplossen/",
        status: "active",
        image:
          "/img/32-condensation-water-droplets-double.jpg",
      },
      {
        title: "Kozijn schilderen of vervangen ?",
        excerpt:
          "Wanneer is schilderen voldoende en wanneer moet een kozijn echt vervangen worden? Kosten, levensduur en onderhoudstips.",
        href: "/blog/kozijn-schilderen-vs-vervangen/",
        status: "active",
        image:
          "/img/66-professional-painter-applying-fresh.jpg",
      },
      {
        title: "Subsidie HR++ glas 2026",
        excerpt:
          "Welke subsidiebedragen gelden er in 2026 voor HR++ beglazing en wat zijn de voorwaarden? Een overzicht van alle regelingen.",
        href: "/blog/subsidie-hr-glas-2026/",
        status: "active",
        image:
          "/img/34-hr-double-glazing-window.jpg",
      },
      {
        title: "ISDE-subsidie aanvragen in Eindhoven",
        excerpt:
          "Hoe vraagt u als Eindhovenaar de ISDE-subsidie aan? Stappenplan, benodigde documenten en gemeentelijke regelingen.",
        href: "/blog/isde-subsidie-eindhoven/",
        status: "active",
        image:
          "/img/52-terraced-house-eindhoven-neighborhood.jpg",
      },
    ],
  },
  schema: {
    blogName: "Blog Ramen Repair Eindhoven",
    blogDescription:
      "Praktische tips over kozijnreparatie, raamonderhoud, ISDE-subsidie 2026 en energiebesparing.",
  },
};

export default nlBlog;